import { createSlice } from "@reduxjs/toolkit";

const chatNotificationsSlice = createSlice({
    name: "chatnotifications",
    initialState: {
        chatNotifications: [],
        readCount: 0,
    },
    reducers: {
        addChatNotification: (state, action) => {
            state.chatNotifications = action.payload;
            state.readCount = action?.payload?.length || 0;
        },
    },
});

export const { addChatNotification } = chatNotificationsSlice.actions;

export default chatNotificationsSlice.reducer;